import { absolutePath } from "./absolutePath";

export const reactions = {
  reactions: () => absolutePath("reactions"),
  communityMembers: (params: Record<string, unknown>) =>
    absolutePath("reactions/community_members", params),
};
